import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';
import {client} from "../../Client";
class CommesseSelect3TableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let c = this.props.commessa
        let linkCommessa=null;
        if (client.getCurrentUser().isrolecommesse) {
            linkCommessa=(<td className="" style={{width:"30px", padding: "0.1em"}}><Link className="right floated" to={"/app/commesse/view/" + c.idCommessa} title="Vai al dettaglio della Commessa"><i className="ui share icon" /></Link></td>)
        }
        //let nomeVisualizzato = c.codice + " " + c.nome + " [" +c.idCommessa+"]";
        //let nomeVisualizzato = c.codice +  " [" +c.idCommessa+ "]"+ " "  +c.nome;
        let nomeVisualizzato = `${c.codice} [${c.idCommessa}] ${c.nome}`;
        if (c.responsabile){
            //nomeVisualizzato = c.codice +  " [" +c.idCommessa+ " - " + c.responsabile + "]"+ " "  +c.nome;
            nomeVisualizzato = `${c.codice} [${c.idCommessa} - ${c.responsabile}] ${c.nome}`;
        }
        if (this.props.selected){
            return (
                <tr>
                    <td className="" style={{padding: "0.1em"}} title={nomeVisualizzato}>
                        <h4 className="ui image content">
                            <label className="ui empty circular large label" style={{backgroundColor: c.colore, marginRight: "5px"}}></label> {nomeVisualizzato}
                        </h4>
                    </td>
                    {linkCommessa}
                </tr>)

        }
        return (
            <tr>
                <td className="pointer selectable" onClick={() => this.props.onCommessaSelect(c)} style={{padding: "0.1em"}} title={nomeVisualizzato}>
                    <p className="ui image content">
                        <label className="ui empty circular label" style={{backgroundColor: c.colore, marginRight: "5px"}}></label>{nomeVisualizzato}
                    </p>
                </td>
                {linkCommessa}
            </tr>)
    }
}

CommesseSelect3TableRow.PropTypes = {
    onCommessaSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
}

export default CommesseSelect3TableRow;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseSelect3TableRow.js
 **/